import { render, staticRenderFns } from "./Aviso.vue?vue&type=template&id=28b9b703&"
import script from "./Aviso.vue?vue&type=script&lang=js&"
export * from "./Aviso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports